// SubmitButton.js
import React from 'react';
import PropTypes from 'prop-types';

const SubmitButton = ({ onSave, text, disabled = false }) => {
  return (
    <div>
      <button 
        style={{
              backgroundColor: disabled ? '#6c757d' : '#007bff',
              color: '#fff',
              border: '1px solid #007bff',
              padding: '5px 15px',
              fontSize: '16px',
              borderRadius: '5px',
              cursor: disabled ? 'not-allowed' : 'pointer',
              textAlign: 'center',
              display: 'inline-block',
              transition: 'background-color 0.3s',
            }}
            onMouseOver={(e) => !disabled && (e.target.style.backgroundColor = '#0056b3')}
            onMouseOut={(e) => !disabled && (e.target.style.backgroundColor = '#007bff')}
        onClick={disabled ? undefined : onSave}
        disabled={disabled}
      >
        {text}
      </button>
    </div>
  );
};

SubmitButton.propTypes = {
  onSave: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default SubmitButton;